// Les Terres de Songon - Mock Data (Refonte)
// Inspiré de OneGreenDev - Immobilier de luxe à Songon, Côte d'Ivoire

export const siteInfo = {
  name: "Les Terres de Songon",
  tagline: "L'art de vivre à Songon",
  location: "Songon, Côte d'Ivoire",
  logo: "LTS"
};

export const heroData = {
  title: "L'art de vivre",
  titleHighlight: "à Songon",
  subtitle: "Le nouveau hub résidentiel aux portes d'Abidjan. Grâce à la nouvelle voie express et au dédoublement de la route de Dabou, Songon n'a jamais été aussi accessible.",
  backgroundImage: "https://images.unsplash.com/photo-1765910639943-889b5cab5be3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBsdXh1cnklMjB2aWxsYSUyMHBvb2wlMjBhZnJpY2F8ZW58MHx8fHwxNzcwMzM1MDgzfDA&ixlib=rb-4.1.0&q=85",
  stats: [
    { value: "30", label: "min d'Abidjan" },
    { value: "120", label: "Hectares" },
    { value: "350+", label: "Lots" }
  ]
};

export const typologiesData = {
  title: "Des résidences d'exception",
  subtitle: "Trois typologies pensées pour répondre à chaque projet de vie",
  types: [
    {
      id: "villas",
      title: "Villas de Luxe",
      subtitle: "L'excellence résidentielle",
      description: "Des villas de standing offrant espace, intimité et raffinement. Architecture moderne avec grandes baies vitrées, jardins paysagers soignés et éclairage extérieur élégant.",
      features: ["300 à 500 m²", "Jardin privatif", "Piscine possible", "Vue golf"],
      image: "https://images.unsplash.com/photo-1721222204126-e7042f2893b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBtb2Rlcm4lMjB2aWxsYSUyMHBvb2wlMjBnbGFzcyUyMGFyY2hpdGVjdHVyZSUyMGdhcmRlbiUyMG5pZ2h0JTIwbGlnaHRpbmd8ZW58MHx8fHwxNzcwMzM3MzU4fDA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: "duplex",
      title: "Duplex",
      subtitle: "L'élégance sur deux niveaux",
      description: "Des duplex contemporains alliant fonctionnalité et modernité. Terrasses privées avec vue dégagée pour une vie familiale épanouie dans un cadre verdoyant.",
      features: ["150 à 250 m²", "Terrasse privée", "Double hauteur", "Parking"],
      image: "https://images.unsplash.com/photo-1762180075273-0527bdc7fa85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob3VzZSUyMHRlcnJhY2UlMjBnYXJkZW4lMjBjb250ZW1wb3Jhcnl8ZW58MHx8fHwxNzcwMzM3NDAzfDA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: "appartements",
      title: "Appartements Haut de Gamme",
      subtitle: "Le confort en résidence",
      description: "Des appartements premium dans des résidences modernes avec façade design, balcons spacieux et finitions de standing dans un cadre urbain aéré et chic.",
      features: ["80 à 150 m²", "Balcon/Terrasse", "Résidence sécurisée", "Espaces communs"],
      image: "https://images.unsplash.com/photo-1758448617677-2f8bebc56d9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjBhcGFydG1lbnQlMjBidWlsZGluZyUyMGV4dGVyaW9yJTIwYmFsY29ueSUyMGZhY2FkZSUyMGRlc2lnbnxlbnwwfHx8fDE3NzAzMzczNjJ8MA&ixlib=rb-4.1.0&q=85"
    }
  ]
};

export const golfData = {
  title: "À deux pas du Golf de Songon",
  subtitle: "Un cadre de vie privilégié",
  description: "Les Terres de Songon bénéficient d'une localisation exceptionnelle, à seulement 500 mètres du Golf de Songon. Un atout majeur pour les amateurs de golf et pour la qualité de vie de tous les résidents.",
  features: [
    "Parcours 18 trous d'exception",
    "Clubhouse & Restaurant",
    "Académie de golf",
    "Espaces de détente"
  ],
  image: "https://images.unsplash.com/photo-1743625749446-f16eefdb1a07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxnb2xmJTIwcHV0dGluZyUyMGdyZWVuJTIwZ3Jhc3MlMjBzdW5ueSUyMGxhbmRzY2FwZSUyMGJlYXV0aWZ1bHxlbnwwfHx8fDE3NzAzMzk1ODR8MA&ixlib=rb-4.1.0&q=85"
};

export const masterplanData = {
  title: "Plan de Morcellement",
  subtitle: "Une vision territoriale structurée",
  description: "Le plan de morcellement des Terres de Songon a été conçu pour optimiser la qualité de vie tout en préservant les espaces verts et la proximité avec le golf.",
  image: "https://customer-assets.emergentagent.com/job_778cf4c4-4ad4-4f2f-8901-fc4411d9f555/artifacts/7d56sv7l_Gemini_Generated_Image_mlp9xhmlp9xhmlp9.png",
  zones: [
    { 
      name: "Zone Villas Premium", 
      percentage: "25%", 
      color: "#2D5A27",
      description: "Villas de luxe avec jardins privatifs et vue sur le golf",
      lots: "87 lots",
      surface: "300-500 m²"
    },
    { 
      name: "Zone Duplex", 
      percentage: "30%", 
      color: "#4A7C4E",
      description: "Duplex modernes avec terrasses et espaces familiaux",
      lots: "105 lots",
      surface: "150-250 m²"
    },
    { 
      name: "Zone Appartements", 
      percentage: "20%", 
      color: "#6B8E6B",
      description: "Résidences sécurisées avec balcons et espaces communs",
      lots: "158 unités",
      surface: "80-150 m²"
    },
    { 
      name: "Espaces Verts", 
      percentage: "15%", 
      color: "#8FBC8F",
      description: "Parcs, jardins paysagers et allées piétonnes",
      lots: "18 hectares",
      surface: "Aménagés"
    },
    { 
      name: "Équipements & Services", 
      percentage: "10%", 
      color: "#B8860B",
      description: "Commerces, école, centre médical et club house",
      lots: "12 hectares",
      surface: "Mutualisés"
    }
  ],
  stats: [
    { label: "Superficie totale", value: "120 ha" },
    { label: "Nombre de lots", value: "350+" },
    { label: "Espaces verts", value: "18 ha" },
    { label: "Voiries", value: "15 km" }
  ]
};

export const philosophyData = {
  quote: "Les projets les plus durables sont ceux qui savent prendre le temps, respecter le lieu et laisser parler le terrain.",
  description: "Les Terres de Songon incarnent une nouvelle vision de l'habitat en Côte d'Ivoire. Un projet pensé pour le long terme, où chaque détail a été conçu pour créer un cadre de vie exceptionnel."
};

export const contactInfo = {
  phone: "+225 07 05 50 97 38",
  email: "contact@onegreendev.com",
  address: "Songon, Côte d'Ivoire"
};

export const accessibilityData = {
  title: "Songon, le nouveau hub résidentiel",
  subtitle: "Une accessibilité exceptionnelle",
  description: "Grâce aux nouvelles infrastructures routières (dédoublement de la route de Dabou, liaison Y4 vers Cocody, nouvelle voie express), Songon est désormais à quelques minutes du cœur d'Abidjan.",
  routes: [
    {
      from: "Abidjan (Le Plateau)",
      to: "Songon",
      duration: "~30 min",
      via: "Via la voie express",
      highlight: true
    },
    {
      from: "Yopougon (Gesco)",
      to: "Songon",
      duration: "~12 min",
      via: "Route directe",
      highlight: false
    },
    {
      from: "Yopougon (Siporex)",
      to: "Songon",
      duration: "~25 min",
      via: "Via carrefour",
      highlight: false
    },
    {
      from: "Carrefour Jacqueville",
      to: "Songon",
      duration: "~5 min",
      via: "Route principale",
      highlight: false
    },
    {
      from: "Aéroport FHB",
      to: "Songon",
      duration: "~50 min",
      via: "4ème pont & autoroute",
      highlight: false
    }
  ],
  infrastructures: [
    "Dédoublement de la route de Dabou",
    "Nouvelle voie express Abidjan-Songon",
    "Liaison Y4 vers Cocody",
    "4ème pont et nouvelle autoroute"
  ]
};

export const navLinks = [
  { label: "Accueil", href: "/" },
  { label: "Résidences", href: "/galerie" },
  { label: "Contact", href: "/contact" }
];

export const footerLinks = {
  navigation: [
    { label: "Accueil", href: "/" },
    { label: "Résidences", href: "/galerie" },
    { label: "Contact", href: "/contact" }
  ],
  legal: [
    { label: "Mentions légales", href: "#" },
    { label: "Confidentialité", href: "#" }
  ]
};

export const galleryImages = [
  {
    id: 1,
    src: "https://images.unsplash.com/photo-1721222204126-e7042f2893b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBtb2Rlcm4lMjB2aWxsYSUyMHBvb2wlMjBnbGFzcyUyMGFyY2hpdGVjdHVyZSUyMGdhcmRlbiUyMG5pZ2h0JTIwbGlnaHRpbmd8ZW58MHx8fHwxNzcwMzM3MzU4fDA&ixlib=rb-4.1.0&q=85",
    title: "Villa de luxe moderne",
    category: "Villas"
  },
  {
    id: 2,
    src: "https://images.unsplash.com/photo-1762180075273-0527bdc7fa85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob3VzZSUyMHRlcnJhY2UlMjBnYXJkZW4lMjBjb250ZW1wb3Jhcnl8ZW58MHx8fHwxNzcwMzM3NDAzfDA&ixlib=rb-4.1.0&q=85",
    title: "Duplex avec terrasse",
    category: "Duplex"
  },
  {
    id: 3,
    src: "https://images.unsplash.com/photo-1758448617677-2f8bebc56d9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjBhcGFydG1lbnQlMjBidWlsZGluZyUyMGV4dGVyaW9yJTIwYmFsY29ueSUyMGZhY2FkZSUyMGRlc2lnbnxlbnwwfHx8fDE3NzAzMzczNjJ8MA&ixlib=rb-4.1.0&q=85",
    title: "Résidence haut de gamme",
    category: "Appartements"
  },
  {
    id: 4,
    src: "https://images.unsplash.com/photo-1629996628328-a35ab39c5e14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBnb2xmJTIwY291cnNlJTIwcmVzaWRlbmNlJTIwYWVyaWFsfGVufDB8fHx8MTc3MDMzNTA4OXww&ixlib=rb-4.1.0&q=85",
    title: "Vue aérienne Golf",
    category: "Golf"
  },
  {
    id: 5,
    src: "https://images.unsplash.com/photo-1765910639943-889b5cab5be3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBsdXh1cnklMjB2aWxsYSUyMHBvb2wlMjBhZnJpY2F8ZW58MHx8fHwxNzcwMzM1MDgzfDA&ixlib=rb-4.1.0&q=85",
    title: "Jardin tropical",
    category: "Extérieurs"
  },
  {
    id: 6,
    src: "https://images.unsplash.com/photo-1759671953272-a4719ca32266?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsdXh1cnklMjBhcGFydG1lbnQlMjBidWlsZGluZyUyMGV4dGVyaW9yJTIwYmFsY29ueSUyMGZhY2FkZSUyMGRlc2lnbnxlbnwwfHx8fDE3NzAzMzczNjJ8MA&ixlib=rb-4.1.0&q=85",
    title: "Balcons végétalisés",
    category: "Appartements"
  }
];
